import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getThumbBySize } from '../../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../../constants/image-size-codes';
import CustomControl from '../../../CustomControl';
import Badge from '../../../Badge';

const propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.string.isRequired,
    thumbnail_urls: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        size_code: PropTypes.oneOf(Object.values(IMAGE_SIZE_CODE)),
      }),
    ),
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
  className: PropTypes.string,
  isPurchased: PropTypes.bool,
};

const CustomPrintPhoto = ({
  photo,
  onSelect,
  isSelected,
  className,
  isPurchased,
}) => {
  const classes = classNames({
    'custom-print-config-photo': true,
    'is-selected': isSelected,
    'is-purchased': isPurchased,
    [className]: !!className,
  });

  return (
    <a
      className={classes}
      href="#"
      onClick={event => {
        event.preventDefault();
        onSelect(photo);
      }}
    >
      {isSelected && (
        <CustomControl
          id={photo.id}
          label="Photo Selected"
          labelSrOnly
          type="checkbox"
          checked
          readOnly
        />
      )}

      <img
        className="custom-print-config-photo-img"
        src={getThumbBySize(photo.thumbnail_urls, IMAGE_SIZE_CODE.MEDIUM)?.url}
        alt=""
      />

      {isPurchased && (
        <Badge badgeStyle="success-vibrant" badgeSize="xs">
          Sent
        </Badge>
      )}
    </a>
  );
};

CustomPrintPhoto.propTypes = propTypes;

export default CustomPrintPhoto;
